var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.model && _vm.model.dentalCaries
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "page dentalCaries-page",
            staticStyle: { margin: "0 auto", border: "0px solid #E8E8EC" },
            attrs: { id: "print_dentalCaries" },
          },
          [
            _c("div", { staticStyle: { height: "50px" } }),
            _c("div", { staticStyle: { "font-size": "18px" } }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.model.dentalCaries.hospitalName
                      ? _vm.model.dentalCaries.hospitalName
                      : ""
                  )
                ),
              ]),
            ]),
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "22px",
                  padding: "20px 0 30px 0",
                  "font-weight": "600",
                },
              },
              [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.model.dentalCaries.reportName
                        ? _vm.model.dentalCaries.reportName
                        : "龋易感性检测报告"
                    )
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "margin-top": "15px",
                  "text-align": "left",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                  "border-bottom": "1px solid rgb(14, 14, 14)",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "35px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("学校："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.dentalCaries.schoolName
                                  ? _vm.model.dentalCaries.schoolName
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("年级："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.dentalCaries.gradeName
                                  ? _vm.model.dentalCaries.gradeName
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("班级："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.dentalCaries.className
                                  ? _vm.model.dentalCaries.className
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "35px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("编号："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.dentalCaries.barCode
                                  ? _vm.model.dentalCaries.barCode
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c("td", {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "none",
                        },
                      }),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("筛查时间："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.dentalCaries.screeningTime
                                  ? _vm.model.dentalCaries.screeningTime
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "35px",
                        width: "100%",
                        "border-collapse": "collapse",
                        "text-align": "left",
                        border: "none",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("姓名："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.dentalCaries.name
                                  ? _vm.model.dentalCaries.name
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("性别："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.dentalCaries.sex
                                  ? _vm.model.dentalCaries.sex
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._v("年龄："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.dentalCaries.age
                                  ? _vm.model.dentalCaries.age
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  width: "98%",
                  "text-align": "left",
                  "margin-top": "20px",
                  "border-bottom": "1px solid rgb(14, 14, 14)",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: { "font-size": "18px", "font-weight": "bold" },
                  },
                  [_vm._v("筛查结果")]
                ),
                _vm._m(0),
                _c(
                  "table",
                  {
                    staticStyle: {
                      width: "80%",
                      "margin-left": "10%",
                      "text-align": "center",
                      "margin-top": "10px",
                      "margin-bottom": "50px",
                      "border-collapse": "collapse",
                      border: "none",
                    },
                  },
                  [
                    _c("tbody", [
                      _vm._m(1),
                      _c("tr", { staticStyle: { "line-height": "35px" } }, [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              width: "100px",
                              "border-collapse": "collapse",
                              border: "none",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.model.dentalCaries.cariogenicBacteriaName
                                  ? _vm.model.dentalCaries
                                      .cariogenicBacteriaName
                                  : ""
                              )
                            ),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              width: "100px",
                              "border-collapse": "collapse",
                              border: "none",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.model.dentalCaries.cariogenicBacteria
                                  ? _vm.model.dentalCaries.cariogenicBacteria
                                  : ""
                              )
                            ),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              width: "100px",
                              "border-collapse": "collapse",
                              border: "none",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.model.dentalCaries
                                  .cariogenicBacteriaReference
                                  ? _vm.model.dentalCaries
                                      .cariogenicBacteriaReference
                                  : ""
                              )
                            ),
                          ]
                        ),
                      ]),
                      _c("tr", { staticStyle: { "line-height": "35px" } }, [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              width: "100px",
                              "border-collapse": "collapse",
                              border: "none",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.model.dentalCaries.catValueName
                                  ? _vm.model.dentalCaries.catValueName
                                  : ""
                              )
                            ),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              width: "100px",
                              "border-collapse": "collapse",
                              border: "none",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.model.dentalCaries.catValue
                                  ? _vm.model.dentalCaries.catValue
                                  : ""
                              )
                            ),
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              width: "100px",
                              "border-collapse": "collapse",
                              border: "none",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.model.dentalCaries.catValueReference
                                  ? _vm.model.dentalCaries.catValueReference
                                  : ""
                              )
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                ),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "margin-top": "10px",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "none",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    {
                      staticStyle: { "text-align": "left" },
                      attrs: { valign: "top" },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._m(2),
                          _c("div", { staticStyle: { "min-height": "20px" } }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.dentalCaries.screeningSummary
                                    ? _vm.model.dentalCaries.screeningSummary
                                    : ""
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    {
                      staticStyle: { "text-align": "left" },
                      attrs: { valign: "top" },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._m(3),
                          _c("div", { staticStyle: { "min-height": "20px" } }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.dentalCaries.recommendations
                                    ? _vm.model.dentalCaries.recommendations
                                    : ""
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    {
                      staticStyle: { "text-align": "left" },
                      attrs: { valign: "top" },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "100px",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _vm._m(4),
                          _c("div", { staticStyle: { "min-height": "20px" } }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.dentalCaries.tips
                                    ? _vm.model.dentalCaries.tips
                                    : ""
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { display: "table", width: "100%" } }, [
      _c(
        "div",
        {
          staticStyle: {
            display: "table-cell",
            width: "12%",
            flex: "1",
            "text-align": "center",
          },
        },
        [
          _c("div", {
            staticStyle: {
              padding: "3px 0",
              height: "40px",
              width: "60px",
              position: "relative",
              top: "0",
              left: "0",
            },
          }),
          _c("div", [_vm._v("CAT值:")]),
        ]
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "table-cell",
            width: "12%",
            flex: "1",
            "text-align": "center",
          },
        },
        [
          _c("div", {
            staticStyle: {
              background: "rgb(83, 97, 164)",
              padding: "3px 0",
              height: "40px",
              width: "60px",
              position: "relative",
              top: "0",
              left: "0",
            },
          }),
          _c(
            "div",
            {
              staticStyle: {
                padding: "3px 0",
                height: "40px",
                width: "60px",
                position: "relative",
                top: "0",
                left: "0",
              },
            },
            [_vm._v("0")]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "table-cell",
            width: "12%",
            flex: "1",
            "text-align": "center",
          },
        },
        [
          _c("div", {
            staticStyle: {
              background: "rgb(93, 137, 134)",
              padding: "3px 0",
              height: "40px",
              width: "60px",
              position: "relative",
              top: "0",
              left: "0",
            },
          }),
          _c(
            "div",
            {
              staticStyle: {
                padding: "3px 0",
                height: "40px",
                width: "60px",
                position: "relative",
                top: "0",
                left: "0",
              },
            },
            [_vm._v("0.5")]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "table-cell",
            width: "12%",
            flex: "1",
            "text-align": "center",
          },
        },
        [
          _c("div", {
            staticStyle: {
              background: "rgb(142, 186, 111)",
              padding: "3px 0",
              height: "40px",
              width: "60px",
              position: "relative",
              top: "0",
              left: "0",
            },
          }),
          _c(
            "div",
            {
              staticStyle: {
                padding: "3px 0",
                height: "40px",
                width: "60px",
                position: "relative",
                top: "0",
                left: "0",
              },
            },
            [_vm._v("1.0")]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "table-cell",
            width: "12%",
            flex: "1",
            "text-align": "center",
          },
        },
        [
          _c("div", {
            staticStyle: {
              background: "rgb(181, 204, 103)",
              padding: "3px 0",
              height: "40px",
              width: "60px",
              position: "relative",
              top: "0",
              left: "0",
            },
          }),
          _c(
            "div",
            {
              staticStyle: {
                padding: "3px 0",
                height: "40px",
                width: "60px",
                position: "relative",
                top: "0",
                left: "0",
              },
            },
            [_vm._v("1.5")]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "table-cell",
            width: "12%",
            flex: "1",
            "text-align": "center",
          },
        },
        [
          _c("div", {
            staticStyle: {
              background: "rgb(181, 204, 103)",
              padding: "3px 0",
              height: "40px",
              width: "60px",
              position: "relative",
              top: "0",
              left: "0",
            },
          }),
          _c(
            "div",
            {
              staticStyle: {
                padding: "3px 0",
                height: "40px",
                width: "60px",
                position: "relative",
                top: "0",
                left: "0",
              },
            },
            [_vm._v("2.0")]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "table-cell",
            width: "12%",
            flex: "1",
            "text-align": "center",
          },
        },
        [
          _c("div", {
            staticStyle: {
              background: "rgb(214, 210, 89)",
              padding: "3px 0",
              height: "40px",
              width: "60px",
              position: "relative",
              top: "0",
              left: "0",
            },
          }),
          _c(
            "div",
            {
              staticStyle: {
                padding: "3px 0",
                height: "40px",
                width: "60px",
                position: "relative",
                top: "0",
                left: "0",
              },
            },
            [_vm._v("2.5")]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticStyle: {
            display: "table-cell",
            width: "12%",
            flex: "1",
            "text-align": "center",
          },
        },
        [
          _c("div", {
            staticStyle: {
              background: "rgb(250, 225, 76)",
              padding: "3px 0",
              height: "40px",
              width: "60px",
              position: "relative",
              top: "0",
              left: "0",
            },
          }),
          _c(
            "div",
            {
              staticStyle: {
                padding: "3px 0",
                height: "40px",
                width: "60px",
                position: "relative",
                top: "0",
                left: "0",
              },
            },
            [_vm._v("3.0")]
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "tr",
      {
        staticStyle: {
          background: "rgb(248, 249, 249)",
          "line-height": "35px",
        },
      },
      [
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("项目名称")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("结果")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              width: "100px",
              "border-collapse": "collapse",
              border: "none",
            },
          },
          [_vm._v("参考值")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticStyle: { "font-size": "16px", "font-weight": "bold" } }, [
        _vm._v("【筛查小结】"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticStyle: { "font-size": "16px", "font-weight": "bold" } }, [
        _vm._v("【建议】"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticStyle: { "font-size": "16px", "font-weight": "bold" } }, [
        _vm._v("【温馨提示】"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }